import { DeepPartial, TermSuggestionsConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_TERM_SUGGESTIONS: DeepPartial<TermSuggestionsConfig> = {
  components: {
    container: 'CdlSuggestions',
    item: 'CdlTermSuggestion'
  }, size: 6
};
